<template>
  <span
    :class="isAnimation ? 'animation-type' : ''"
    class="icon"
    v-html="icon"
  />
</template>
<script>
const svgContext = require.context('../../assets/icons/', false, /\.svg/);

export default {
  name:  'Icon',
  props: {
    name: {
      type:     String,
      required: true,
    },
    stroke: {
      type:    String,
      default: '#3F3F3F',
    },
    isAnimation: Boolean,
  },
  computed: {
    icon() {
      return svgContext(`./${this.name}.svg`);
    },
  },
};

</script>
<style lang="scss">
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 1.6rem;
    min-width: 1.6rem;
  }
  .animation-type{
    width: 77px;
    height: 77px;
    svg{
      width: 77px;
      height: 77px;
    }
  }

</style>
